import { render, staticRenderFns } from "./custom-secure-block.vue?vue&type=template&id=08c83164&"
import script from "./custom-secure-block.vue?vue&type=script&lang=js&"
export * from "./custom-secure-block.vue?vue&type=script&lang=js&"
import style0 from "./custom-secure-block.vue?vue&type=style&index=0&id=08c83164&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports